// ============================================
// モジュール読み込み
// ============================================
import { viewport } from './libs/switchViewport';
import { bgBlack, contactAnim, headAnim, innovateAnim, inViewAnm, lenisPageScroll, mvAnim, numberCountUp, recruitAnim, secondLoadingAnim, serviceAnim } from './libs/Scroll';
import { drawer, fixedHeader, megaMenu, switchHeaderLogo } from './libs/Header';
import { threeAnim } from './libs/ThreeAnim';
import { mapClick } from './libs/mapClick';
import { contactForm } from './libs/Form';
import { accordionFunc } from './libs/Accordion';
import { galleryFlip } from './libs/Gallery';
// import { articleTable, ScrollHintFunc } from './libs/ScrollHint';
// import { slider } from './libs/Slider';
// import { tabFunc } from './libs/Tab';

// 実行
// ==========================
window.addEventListener('DOMContentLoaded', () => {
  viewport();
  fixedHeader();
  switchHeaderLogo();
  drawer();
  megaMenu();
  lenisPageScroll();
  threeAnim();
  contactForm();
  accordionFunc();
  galleryFlip();
  // articleTable();
  // ScrollHintFunc();
  // tabFunc();
});

window.addEventListener('load', () => {
  document.body.classList.add('is-loaded');
  inViewAnm();
  headAnim();
  numberCountUp();
  mvAnim();
  secondLoadingAnim();
  serviceAnim();
  mapClick();
  innovateAnim();
  recruitAnim();
  contactAnim();
  bgBlack();
  // slider();
});
